module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/qYQKd9/tc-custom/9781555846176.jpg?1699740118753",
      "alt": "This image is the cover for the book Four Blondes"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Four Blondes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The "), _c('i', [_vm._v("New York Times")]), _vm._v(" bestseller that “chronicles the glittering lives of semicelebrities, social aspirants, and moneyed folk [with] withering precision” ("), _c('i', [_vm._v("The New York Times")]), _vm._v("). ")]), _c('br'), _c('br'), _vm._v("From the author of "), _c('i', [_vm._v("Sex and the City")]), _vm._v(", this collection of novellas tells the stories of four women facing up to the limitations of their rapidly approaching middle age in an era that worships youth. From the former it-girl heroine of “Nice N’Easy,” who each summer looks for a rich man who’ll provide her with a house in the Hamptons, to the narrator of “Single Process,” who goes to London on a hunt for love and a good magazine story, Candace Bushnell brings to life contemporary women in search of something more—when the world is pushing for them to settle for less. Sexy, funny, and “mercilessly satirical” ("), _c('i', [_vm._v("Publishers Weekly")]), _vm._v("), "), _c('i', [_vm._v("Four Blondes")]), _vm._v(" is a knowing look at what lurks beneath our obsessions with sex, celebrity, and social status."), _c('br'), _c('br'), _vm._v("“Stiletto-sharp wit and dialogue…A compulsive read.”—"), _c('i', [_vm._v("OK Magazine")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Candace Bushnell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("A seasoned freelance writer, Candace Bushnell wrote the SEX AND THE CITY column for many years. She is also a regular contributor to VOGUE. She lives in New York City.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grove Press Book\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0